import styled from "styled-components";

import { Link } from 'react-router-dom';

export const Container = styled.div``;

export const Content = styled.main`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 72px 0 50px;

  position: relative;

  @media (max-width: 1170px){
    width: 100%;
    margin: 0;
    padding: 72px 0 150px;
  }
`;

export const ReturnButton = styled(Link)`
  position: absolute;
  top: 29px;
  left: 32px;

  .gains__content-icon{
    height: 20px;
    width: auto;
    stroke: #000;
  }
`

export const GainsSection = styled.section`
  width: 95%;
  max-width: 1204px;
  height: fit-content;
  margin: 0 auto;

  display: flex;
  justify-content: space-between;

  .gains__wallet-wrapper{
    width: 100%;
    max-width: 454px;
    height: fit-content;
  }

  .gains__wallet-title{
    margin-top: 17px;

    color: var(--blue00);
    font-size: 1.625rem;
    font-weight: bold;
  }

  .gains__wallet{
    width: 100%;
    height: fit-content;
    min-height: 218px;
    margin-top: 27px;
    padding: 29px 14.5px 22px 17.4px;

    display: flex;

    border-radius: 39px;
    background-color: #fff;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.33);
  }

  .gains__wallet-icon{
    width: 5.756875rem;
    height: 5.756875rem;
  }

  .gains__wallet-content{
    width: 100%;
    padding: 0 25.5px;

    display: flex;
    flex-direction: column;

    position: relative;
  }

  .gains__wallet-content__title{
    color: #8E92A7;
    font-size: 1.3125rem;
  }

  .gains__wallet-content__subtitle{
    margin-top: 6px;

    font-size: 0.875rem;
    color: var(--blue00);
  }

  .gains__wallet-content__subsubtitle {
    font-size: 0.875rem;
    color: var(--blue00);

    margin-top: 8px;
  }

  .gains__wallet-content__subvalue {
    color: var(--blue00);
    margin-top: 4px;
  }

  .gains__wallet-content__value{
    margin-top: 6px;

    color: var(--blue00);
    font-size: 2.5rem;
    font-weight: bold;
  }

  .gains__wallet-content__button{
    width: 169px;
    height: 48px;
    margin-top: 29px;

    border-radius: 24px;
    align-self: flex-end;
    background-color: var(--blue00);
    border: 0;
    outline: 0;
    color: #fff;
    font-size: 1.4375rem;
    cursor: pointer;
    transition: 0.3s filter ease;

    &:hover{
      filter: brightness(1.2);
    }
  }

  .gains__wallet-content__view-button,
  .gains__wallet-content__view-button--closed{
    position: absolute;
    right: 25px;

    display: block;

    border: 0;
    outline: none;
    background-color: transparent;
    cursor: pointer;
    transition: 0.3s filter ease;

    &:hover{
      filter: brightness(1.2);
    }
  }

  .gains__wallet-content__view-button{
    width: 38.77px;
    height: 28.19px;

    top: 8px;
  }

  .gains__wallet-content__view-button--closed{
    width: 39.95px;
    height: 39.95px;

    top: 2px;
  }

  .gains__wallet-content__view{
    width: 100%;
    height: 100%;
  }

  .gains__historic{
    width: 100%;
    max-width: 556px;
    height: fit-content;
    padding: 43px 29px 28px;

    border-radius: 41px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.39);
    background-color: #fff;
  }

  .gains__historic-title{
    color: var(--blue00);
    font-size: 1.625rem;
    font-weight: bold;
  }

  .gains__historic-filter-container{
    width: 100%;
    height: fit-content;
    margin-top: 28.8px;
    padding: 27.8px 0 13.3px;

    background-color: var(--bluef0);
    border-radius: 20px;
  }

  .gains__historic-filter{
    width: 90%;
    margin: 0 auto;
  }

  .gains__historic-filter-total{
    width: 90%;
    height: fit-content;
    margin: 2rem auto 0;

    color: var(--blue00);
    line-height: 1.8rem;
    text-align: right;
    font-size: 1.4375rem;
  }

  .gains__historic-filter-total-b{
    color: #ADACAC;
    font-size: 1.625rem;
    font-weight: lighter;
  }

  .gains__receipt-article__content{
    position: relative;
  }

  .gains__receipt-title{
    margin-top: 28.9px;

    color: var(--blue00);
    font-size: 1.4375rem;
  }

  .gains__receipt-ul{
    margin-top: 51.9px;
  }

  .gains__receipt-li:not(:first-child){
    margin-top: 16px;
  }

  .gains__receipt-article{
    width: 100%;
    height: fit-content;
    padding: 10.4px 26.7px 28.8px;

    border-radius: 12px;
    background-color: var(--bluef0);
  }

  .gains__receipt-article__title{
    max-width: 70%;
    color: var(--blue00);
    font-size: 0.9375rem;
  }

  .gains__receipt-article__info{
    margin-top: 6px;

    color: #001383;
    font-size: 0.8rem
  }

  .gains__receipt-article__n{
    position: absolute;
    top: 0;
    right: 0;

    color: #7A7A7A;
    font-size: 0.8rem
  }

  .gains__receipt-info{
    text-align: center;
    color: var(--blue00);
  }

  @media (max-width: 1283px) {
    flex-direction: column;
    gap: 20px;
  }
`
